'use client'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import { Dialog, Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import IndiaNavbar from '@/components/Layout/india-navbar'

import Link from 'next/link'
import { usePathname, useRouter } from 'next/navigation'
import { Fragment, useEffect, useRef, useState } from 'react'
const navigation = [
  { name: 'About', href: '/about' },
  { name: 'Team', href: '/team' },
  { name: 'Mentors', href: '/mentors' },
  { name: 'Partner', href: '/partner' },
  { name: 'Events', href: '/events' },
  // { name: 'Media', href: '/media' },
  { name: 'Apply', href: '/apply' },
]
const navigationHackathon = [
  { name: 'Home', href: '/niyo' },
  { name: 'About', href: 'About' },
  { name: 'Competitions', href: 'Competitions' },
]
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export function Header({ session }) {
  const { isLoading, signOut, avatar_url, isCompany } = useAuth()
  const isSuperAdmin =
    session?.user?.app_metadata?.claims_admin === 'super-admin'
  const isAdmin = session?.user?.app_metadata?.claims_admin === 'admin'

  const isFounder = session?.user?.app_metadata?.role === 'founder'
  
  // Check if we're on a preview deployment
  // Decided after mount so server and client render the same markup
  const [isPreview, setIsPreview] = useState(false)
  useEffect(() => {
    const host = window.location.hostname
    setIsPreview(
      (host.includes('vercel.app') || host.includes('localhost')) &&
        !host.includes('aiforge.org'),
    )
  }, [])
  const redirectToDashboard = () => {
    let destination

    if (isFounder) {
      destination = isCompany ? '/i/getting-started' : '/i/applications'
    } else if (isSuperAdmin || isAdmin) {
      destination = '/i/admin/dashboard'
    } else {
      destination = '/i/profile'
    }

    router.push(destination)
    window.history.replaceState(null, '', destination)
  }

  const environment = process.env.NEXT_PUBLIC_VERCEL_ENV
  const wrapperRef = useRef(null)
  const wrapperRefT = useRef(null)
  const { isUserPending, isAuthenticated, user } = {
    isAuthenticated: session,
    isUserPending: isLoading,
    user: session?.user,
  }

  const pathname = usePathname(null)
  const isVote =
    !isAdmin &&
    !isSuperAdmin &&
    pathname?.includes('vote') &&
    !pathname?.includes('admin') &&
    !pathname?.includes('mentor') &&
    !pathname?.includes('company')
  const isNiyo = pathname?.includes('niyo')
  const isIndia = pathname?.startsWith('/india')
  const isHome = pathname === '/'
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [show, setShow] = useState(false)
  const router = useRouter()
  const handleLogout = async (e) => {
    e.preventDefault()
    try {
      await signOut()
      setMobileMenuOpen(false)
      router.push('/')
    } catch (error) {
      console.error(error)
    }
  }
  const goToPage = async (path) => {
    setMobileMenuOpen(false)
    router.push(path)
  }
  const getName = () => {
    return (
      user?.user_metadata?.new_name ||
      user?.user_metadata?.name ||
      user?.user_metadata?.full_name ||
      user?.email.split('@')[0]
    )
  }

  const userNavigation = [
    { name: 'Profile', path: '/i/profile' },
    { name: 'Sign out', action: handleLogout },
  ]
  const userFounderNavigation = [
    { name: 'Profile', path: '/i/profile' },
    { name: 'My Applications', path: '/i/applications' },
    { name: 'Sign out', action: handleLogout },
  ]
  const appNavigation = isFounder ? userFounderNavigation : userNavigation

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        wrapperRefT.current &&
        !wrapperRefT.current.contains(event.target)
      ) {
        // The click was outside both components, handle it!
        setShow(false)
      }
    }

    // Add the click event listener
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      // Remove the event listener when the component is unmounted
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  if (isVote) return null
  if (isIndia) return <IndiaNavbar />
  if (isNiyo)
    return (
      <header className=" relative z-20  bg-[rgba(29,29,33,0.25)] border-b border-[rgba(207,213,220,0.1)] backdrop-blur-[25px]">
        <nav
          className="mx-auto flex max-w-7xl items-center justify-between p-6 py-8 lg:px-8 relative z-10"
          aria-label="Global"
        >
          <div className="flex">
            <Link href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img
                src="/logo_white.svg"
                className=" md:h-[22px] md:w-[139.81px]"
                alt="AI Forge Logo"
              />
            </Link>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>

              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-6 xl:gap-x-12">
            {navigationHackathon.map((item, i) =>
              environment === 'productionTest' &&
              item.name === 'Investors' ? null : item.href.includes('/') ? (
                <Link
                  key={i}
                  href={item.href}
                  className="text-md font-semibold leading-6 !no-underline !text-white hover:text-blue-200 hover:duration-300"
                >
                  {item.name}
                </Link>
              ) : (
                <a
                  href={'#' + item.href}
                  className="text-md font-semibold leading-6 !no-underline !text-white hover:text-blue-200 hover:duration-300"
                >
                  {item.name}
                </a>
              ),
            )}
          </div>
          <div className="hidden lg:flex  lg:justify-end">
            <div className="flex items-center gap-4">
              <Link
                href="/apply"
                onClick={() => setMobileMenuOpen(false)}
                className="bg-white hover:bg-white/90 hover:shadow-[#155EEF] flex items-center justify-center rounded-[88px] h-[44px] w-[121px] text-[#18181B] text-base font-semibold leading-6"
              >
                Apply now
              </Link>
            </div>
          </div>
        </nav>
        <Dialog
          as="div"
          className="lg:hidden"
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
        >
          <div className="fixed inset-0 z-10" />
          <Dialog.Panel className="fixed z-50 inset-y-0 right-0 z-10 w-full overflow-y-auto bg-gray-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-white/10">
            <div className="flex items-center justify-between">
              <Link href="#" className="-m-1.5 p-1.5">
                <span className="sr-only">AI Forge</span>
                <img
                  className="h-8 w-auto"
                  src="/logo_white.svg"
                  alt="AI Forge Logo"
                />
              </Link>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-400"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/25">
                <div className="space-y-2 py-6">
                  {navigationHackathon.map((item, i) =>
                    item.href.includes('/') ? (
                      <Link
                        key={i}
                        href={item.href}
                        onClick={() => setMobileMenuOpen(false)}
                        className="-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 !no-underline !text-white"
                      >
                        {item.name}
                      </Link>
                    ) : (
                      <a
                        href={'#' + item.href}
                        onClick={() => setMobileMenuOpen(false)}
                        className="-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 !no-underline !text-white"
                      >
                        {item.name}
                      </a>
                    ),
                  )}
                </div>
                <div className="py-6 justify-center">
                  <Link
                    href="/apply"
                    onClick={() => setMobileMenuOpen(false)}
                    className="-mx-3 block rounded-lg py-2.5 px-3 text-base font-semibold leading-7 text-white"
                  >
                    Apply now
                  </Link>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
    )
  return (
    <header
      className={
        isHome
          ? 'relative z-20 border-b border-[rgba(207,213,220,0.1)] backdrop-blur-[25px]'
          : 'bg-gray-900/30 relative z-20 border-b border-[#26272B] '
      }
    >
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 py-8 lg:px-8 relative z-10"
        aria-label="Global"
      >
        <div className="flex items-center gap-3">
          <Link href="/" className="-m-1.5 p-1.5">
            <span className="sr-only">Your Company</span>
            <img
              src="/logo_white.svg"
              className=" md:h-[22px] md:w-[139.81px]"
              alt="AI Forge Logo"
            />
          </Link>
          {isPreview && (
            <span className="px-2 py-1 text-xs font-semibold text-orange-500 bg-orange-500/10 border border-orange-500/20 rounded">
              PREVIEW
            </span>
          )}
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            {isAuthenticated ? (
              avatar_url ? (
                <img
                  onClick={() => {
                    // router.push('/i')
                    setShow(false)
                  }}
                  className="h-[35px] w-[35px] rounded-full bg-gray-50 object-cover"
                  src={avatar_url}
                  alt=""
                />
              ) : (
                !isLoading && (
                  <span
                    onClick={() => {
                      // router.push('/i')
                      setShow(false)
                    }}
                    className="inline-flex h-[35px] w-[35px] items-center justify-center rounded-full bg-gray-500"
                  >
                    <span className="text-xs font-medium leading-none text-white uppercase">
                      {user?.user_metadata?.new_name?.slice(0, 2) ||
                        user?.user_metadata?.name?.slice(0, 2) ||
                        user?.email.split('@')[0]?.slice(0, 2)}
                    </span>
                  </span>
                )
              )
            ) : (
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            )}
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-6 xl:gap-x-12">
          {navigation.map((item) =>
            environment === 'productionTest' &&
            item.name === 'Investors' ? null : (
              <Link
                key={item.name}
                href={item.href}
                className="text-md font-semibold leading-6 !no-underline !text-white hover:text-blue-200 hover:duration-300"
              >
                {item.name}
              </Link>
            ),
          )}
        </div>
        <div className="hidden lg:flex  lg:justify-end">
          {!isAuthenticated ? (
            !isUserPending ? (
              <div className="flex items-center gap-4">
                <Link
                  href="/india"
                  className="mr-2 flex items-center hover:opacity-80 transition-opacity"
                >
                  <img
                    src="https://flagcdn.com/in.svg"
                    alt="India"
                    className="h-[18px] w-auto rounded-[2px]"
                  />
                </Link>
              </div>
            ) : (
              ''
            )
          ) : (
            <div className="flex  items-center">
              <Link
                href="/india"
                className="mr-5 flex items-center hover:opacity-80 transition-opacity"
              >
                <img
                  src="https://flagcdn.com/in.svg"
                  alt="India"
                  className="h-[18px] w-auto rounded-[2px]"
                />
              </Link>
              <div
                onClick={() => redirectToDashboard()}
                className="ml-4  flex items-center justify-center  cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M6.66667 14.1667H13.3333M9.18141 2.30335L3.52949 6.69929C3.15168 6.99314 2.96278 7.14006 2.82669 7.32406C2.70614 7.48705 2.61633 7.67067 2.56169 7.86589C2.5 8.08628 2.5 8.3256 2.5 8.80423V14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5H14.8333C15.7668 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7668 17.5 14.8333V8.80423C17.5 8.3256 17.5 8.08628 17.4383 7.86589C17.3837 7.67067 17.2939 7.48705 17.1733 7.32406C17.0372 7.14006 16.8483 6.99314 16.4705 6.69929L10.8186 2.30335C10.5258 2.07564 10.3794 1.96178 10.2178 1.91802C10.0752 1.8794 9.92484 1.8794 9.78221 1.91802C9.62057 1.96178 9.47418 2.07564 9.18141 2.30335Z"
                    stroke="#FFFFFF"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <Menu as="div" className=" relative">
                <Menu.Button className="-m-1.5 flex relative items-center ">
                  <span className="sr-only">Open user menu</span>

                  <span className="hidden lg:flex lg:items-center">
                    <span
                      onClick={() => {
                        setShow(false)

                        const path =
                          (isCompany && isFounder) || isAdmin || isSuperAdmin
                            ? '/i/getting-started'
                            : isFounder
                            ? '/i/applications'
                            : '/i/profile'
                        console.log('path', path, isFounder)
                        router.push(path)
                      }}
                      className=" text-[16px] font-[500] leading-6 text-white cursor-pointer xl:mx-4"
                      aria-hidden="true"
                    >
                      {`${getName()}`}
                    </span>
                    <span ref={wrapperRef} onClick={() => setShow(!show)}>
                      {!show ? (
                        <ChevronDownIcon
                          className=" h-8 w-8 mt-1 text-white"
                          aria-hidden="true"
                        />
                      ) : (
                        <ChevronUpIcon
                          className=" h-8 w-8 mt-1 text-white"
                          aria-hidden="true"
                        />
                      )}
                    </span>
                  </span>
                </Menu.Button>
                {show && (
                  <Transition
                    show={true}
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items
                      ref={wrapperRefT}
                      className="absolute flex pt-[10.07px] flex-col  right-0 z-50 mt-2.5 w-[190px] origin-top-right rounded-md bg-[#171717] shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
                    >
                      <div
                        // onClick={item.action}
                        className={classNames(
                          'block px-3 w-full text-left py-2 px-[13.43px] text-sm leading-6 text-white',
                        )}
                      >
                        <div className="text-xs text-[#DCDCDC]">
                          Signed in as
                        </div>
                        <div className="text-xs text-[#DCDCDC] font-[600]">
                          {user?.email}
                        </div>
                      </div>
                      <div className="border-b border-[#3d4044] mt-2"></div>

                      {isSuperAdmin && (
                        <div
                          className={classNames(
                            'block px-3 w-full text-left py-2 px-[13.43px] text-sm leading-6 text-white',
                          )}
                        >
                          <div
                            onClick={() => {
                              setShow(false)
                              router.push('/i/admin/dashboard')
                            }}
                            className="cursor-pointer  text-xs flex gap-4 items-center text-white leading-6 font-[500] "
                          >
                            Admin Panel
                          </div>
                        </div>
                      )}
                      {isAdmin && (
                        <div
                          className={classNames(
                            'block px-3 w-full text-left py-2 px-[13.43px] text-sm leading-6 text-white',
                          )}
                        >
                          <div
                            onClick={() => {
                              setShow(false)
                              router.push('/i/getting-started')
                            }}
                            className="cursor-pointer  text-xs flex gap-4 items-center text-white leading-6 font-[500] "
                          >
                            Admin Panel
                          </div>
                        </div>
                      )}

                      {appNavigation.map((item, i) => (
                        <Menu.Item
                          className={`${
                            i === 2 ? 'border-b border-[#3d4044]' : ''
                          } hover:bg-gray-700`}
                          key={item.name}
                        >
                          {({ active }) => (
                            <div
                              onClick={(e) => {
                                if (item.action) {
                                  item.action(e)
                                } else {
                                  goToPage(item.path)
                                }
                                setShow(false)
                              }}
                              className={classNames(
                                active ? 'bg-transparent' : '',
                                i === 2 ? ' pb-3 pt-2' : 'py-2',
                                'block px-3 w-full text-left px-[13.43px] font-[500] text-xs leading-6 !text-white cursor-pointer',
                              )}
                            >
                              {item.name}
                            </div>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                )}
              </Menu>
            </div>
          )}
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed z-50 inset-y-0 right-0 z-10 w-full overflow-y-auto bg-gray-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-white/10">
          <div className="flex items-center justify-between">
            <Link href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">AI Forge</span>
              <img
                className="h-8 w-auto"
                src="/logo_white.svg"
                alt="AI Forge Logo"
              />
            </Link>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-400"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/25">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    href={item.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className="-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 !no-underline !text-white"
                  >
                    {item.name}
                  </Link>
                ))}
                <Link
                  href="/india"
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 flex items-center gap-2 rounded-lg py-2 px-3 text-base font-semibold leading-7 !no-underline !text-white hover:text-orange-400 transition-colors"
                >
                  <img
                    src="https://flagcdn.com/in.svg"
                    alt="India"
                    className="h-[14px] w-auto rounded-[2px]"
                  />
                  <span>India</span>
                </Link>
                {isFounder && (
                  <Link
                    href={'/i/applications'}
                    onClick={() => setMobileMenuOpen(false)}
                    className="-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 !no-underline !text-white"
                  >
                    My Applications
                  </Link>
                )}
              </div>
              <div className="py-6 justify-center">
                {isAuthenticated && (
                  <div className="flex items-center justify-between">
                    <Link
                      href={
                        (isCompany && isFounder) || isAdmin || isSuperAdmin
                          ? '/i/getting-started'
                          : isFounder
                          ? '/i/applications'
                          : '/i/profile'
                      }
                      onClick={() => setMobileMenuOpen(false)}
                      className="-mx-3 flex items-center justify-between rounded-lg py-2 px-3 text-base font-semibold leading-7 text-white"
                    >
                      <div className="flex items-center gap-1">
                        {avatar_url ? (
                          <img
                            onClick={() => {
                              router.push('/i')
                              setShow(false)
                            }}
                            className="h-[35px] w-[35px] rounded-full bg-gray-50 object-cover"
                            src={avatar_url}
                            alt=""
                          />
                        ) : (
                          isLoading && (
                            <span
                              onClick={() => {
                                router.push('/i')
                                setShow(false)
                              }}
                              className="inline-flex h-[35px] w-[35px] items-center justify-center rounded-full bg-gray-500"
                            >
                              <span className="text-xs font-medium leading-none text-white uppercase">
                                {user?.user_metadata?.new_name?.slice(0, 2) ||
                                  user?.user_metadata?.name?.slice(0, 2) ||
                                  user?.email.split('@')[0]?.slice(0, 2)}
                              </span>
                            </span>
                          )
                        )}
                        <span
                          className="ml-4 text-[16px] font-[500] leading-6 text-white cursor-pointer"
                          aria-hidden="true"
                        >
                          {`${getName()}`}
                        </span>
                      </div>
                    </Link>
                    <div className="cursor-pointer" onClick={handleLogout}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.3333 13.1667L16.5 9M16.5 9L12.3333 4.83333M16.5 9H6.5M6.5 1.5H5.5C4.09987 1.5 3.3998 1.5 2.86502 1.77248C2.39462 2.01217 2.01217 2.39462 1.77248 2.86502C1.5 3.3998 1.5 4.09987 1.5 5.5V12.5C1.5 13.9001 1.5 14.6002 1.77248 15.135C2.01217 15.6054 2.39462 15.9878 2.86502 16.2275C3.3998 16.5 4.09987 16.5 5.5 16.5H6.5"
                          stroke="#FFFFFF"
                          strokeWidth="1.66667"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  )
}
